import type { Theme } from "@/lib/models/manuscript";

/**
 * エディタテーマの決定ロジック
 * カラーモードが選択されていない場合、全体のアプリテーマに基づいて決定する
 * @param storeTheme - Vuexストアから取得したエディタテーマ（null, undefined, 空文字列の場合は未設定）
 * @param effectiveAppTheme - アプリ全体の実効テーマ（"light" | "dark"）
 * @returns エディタテーマ（"default" | "dark" | "bold" | "sepia" | "blackboard"）
 */
export function getEffectiveEditorTheme(storeTheme: string | null | undefined, effectiveAppTheme: "light" | "dark"): Theme {
  // エディタテーマが設定されている場合はそのまま返す
  if (storeTheme && storeTheme !== "") {
    return storeTheme as Theme;
  }

  // アプリテーマが "dark" の場合は "dark"、それ以外（"light"）は "default" を返す
  return effectiveAppTheme === "dark" ? "dark" : "default";
}
